import { render, staticRenderFns } from "./ProductsBag.vue?vue&type=template&id=6a3d124d&"
import script from "./ProductsBag.vue?vue&type=script&lang=js&"
export * from "./ProductsBag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports